// extracted by mini-css-extract-plugin
export var activeDot = "_29-c";
export var buttonContainer = "_29-9";
export var channelButton = "_29-a";
export var clickable = "_29-d";
export var content = "_29-0";
export var contentFull = "_29-2";
export var contentThird = "_29-1";
export var contentWrapper = "_29-7";
export var description = "_29-5";
export var heightShort = "_29-f";
export var image = "_29-3";
export var imageContainer = "_29-4";
export var selectButton = "_29-e";
export var spinnerContainer = "_29-b";
export var titleContent = "_29-8";
export var titleWrapper = "_29-6";